function HomeFunctionality() {
    const homePageScene = document.getElementById('scene')

    if (homePageScene) {
        setupHomeParallaxScene()
    }

    function setupHomeParallaxScene() {
        // Using Parallax CDN Script
        new Parallax(homePageScene, {
            relativeInput: true
        })
    }

}

export default HomeFunctionality